import { css } from 'styled-components';
import colors from '../../../sass/colors';

const small = css`
  height: 1.50rem;
`;
const medium = css`
  height: 2.00rem;
`;
const large = css`
  height: 2.50rem;
`;

const size = {
  small,
  medium,
  large,
};

const common = css`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 0.25rem;
  font-size: 0.88rem;
  line-height: 1.25rem;
  gap: 0.5em;
`;

const borderless = css`
  border: none;
  border-radius: 0;
  &:hover,
  &:active,
  &focus {
    border: none;
  }
`;

const base = css`
  color: ${colors.neutral100};
  background-color: ${colors.neutral20};
  ${borderless};
  &:hover {
    color: ${colors.neutral100};
    background-color: ${colors.neutral10};
  }
  &:focus {
    color: ${colors.neutral100};
    background-color: ${colors.neutral10};
    box-shadow: 0px 0px 0px 3px rgba(0, 146, 228, 0.25);
  }
  &:active {
    color: ${colors.neutral100};
    background-color: ${colors.neutral30};
  }

  path {
    fill: ${colors.neutral60};
  }
`;

const cancel = css`
  color: ${colors.neutral100};
  background-color: ${colors.white};
  box-shadow: none !important;
  ${borderless};
  &:hover {
    color: ${colors.neutral100};
    background-color: ${colors.neutral20};
  }
  &:focus {
    color: ${colors.neutral100};
    background-color: ${colors.neutral10};
    box-shadow: 0px 0px 0px 3px rgba(0, 146, 228, 0.25);
  }
  &:active {
    color: ${colors.neutral100};
    background-color: ${colors.neutral30};
  }

  path {
    fill: ${colors.neutral60};
  }
`;

const cancelDark = css`
  color: var(--white);
  background-color: var(--neutral-80);
  box-shadow: none;
  border: 0;
  border-radius: 4px;

  &:hover,
  &:focus {
    color: var(--white);
    background-color: var(--neutral-100);
  }
`;

const primary = css`
  color: ${colors.white};
  background-color: ${colors.green60};
  ${borderless};
  &:hover {
    color: ${colors.white};
    background-color: ${colors.green50};
  }
  &:focus {
    color: ${colors.white};
    background-color: ${colors.green50};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }
  &:active {
    color: ${colors.white};
    background-color: ${colors.green70};
  }

  path {
    fill: ${colors.white};
  }
`;

const outline = css`
  color: ${colors.neutral100};
  background-color: transparent;
  border: 0 solid ${colors.neutral30};
  &:hover {
    border-width: 1px;
  }
  &:focus {
    box-shadow: 0 0 0 3px rgba(0, 146, 228, 0.25);
    border-width: 1px;
  }
  &:active {
    border-width: 1px;
  }
`;

const danger = css`
  color: ${colors.red50};
  background-color: ${colors.neutral10};
  ${borderless};
  &:hover,
  &:focus,
  &:active {
    background-color: ${colors.white};
    color: ${colors.red50};
  }

  path {
    fill: ${colors.red50};
  }
`;

const attachment = css`
  color: ${colors.neutral100};
  background: ${colors.white};

  &:hover,&:focus, &:active {
    color: ${colors.neutral100};
    background: ${colors.neutral10};
    border-color: #e0e3e8
  }
}
`;

const topBar = css`
  box-shadow: none;
  background: ${colors.white};
  border-color: #ffffff;

  &:hover,
  &:focus,
  &:active {
    background: ${colors.neutral20};
    border-color: ${colors.neutral20};
  }
`;

const overlay = css`
  color: ${colors.neutral100};
  background-color: ${colors.white};
  ${borderless};
  box-shadow: 0px 2px 4px rgba(92, 101, 117, 0.3), 0px 0px 1px rgba(92, 101, 117, 0.47);
  &:hover {
    color: ${colors.neutral100};
    background-color: ${colors.background};
  }
  &:focus {
    color: ${colors.neutral100};
    background-color: ${colors.neutral10};
  }
  &:active {
    color: ${colors.neutral100};
    background-color: ${colors.neutral20};
  }

  path {
    fill: ${colors.neutral60};
  }
`;

const mapTop = css`
  ${size.large};
  ${overlay};

  svg {
    margin-right: 0.39rem;
  }
`;

const mapRightFlat = css`
  ${size.small};
  ${overlay};
  width: 7.50rem;
  padding: 0;

  svg {
    margin-right: 0.31rem;
  }
`;

const circle = css`
  border-radius: 50% !important;
`;

const variant = {
  base,
  primary,
  outline,
  danger,
  overlay,
  attachment,
  topBar,
  cancel,
  cancelDark,
};

const group = {
  mapTop,
  mapRightFlat,
};

const shape = {
  circle,
};

export { common, size, variant, group, shape };
